import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { getKnowledgeFiles } from '@/redux/requests/knowledgeFilesRequests.js';
import KnowledgeDocumentPage from './pages/KnowledgeDocumentPage.jsx';
import KnowledgePage from './pages/KnowledgePage.jsx';
import './styles/knowledge.css';

/** Knowledge: the organization's notes, and one note open to write or edit (`/knowledge/new` starts one). */
const KnowledgeScreen = () => {
  const { documentName } = useParams();

  useEffect(() => {
    getKnowledgeFiles({ root: 'organization' });
  }, []);

  return documentName ? <KnowledgeDocumentPage key={documentName} documentName={documentName} /> : <KnowledgePage />;
};

export default KnowledgeScreen;
